/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export class CellTypes {
    static DEFAULT: string = 'DEFAULT';

    static PAST_CONTINUOUS: string = 'PAST_CONTINUOUS';

    static FUTURE_CONTINUOUS: string = 'FUTURE_CONTINUOUS';

    static TRAILING: string = 'TRAILING';

    static LEADING: string = 'LEADING';
}
